import uploadloprlop from './loprlop/uploadloprlop.js'
import viewloprlop from './loprlop/viewloprlop.js'
import addexitemployees from './addexitemployees/addexitemployees.js'
import settlefbpclaims from './fbpClaims/settlefbpclaims.js'
import assign_fbp_components from './assignfbpcomponents/assignfbp.js'
import get_fbp from './assignfbpcomponents/getfbp.js'
import uploadFbpClaim from './fbpClaims/uploadFbpClaim.js'
import revisesalary from './revisesalary/revisesalary.js'
import statutoryBonus from './statutorybonus/stattutorybonus.js'
import leaves_attendance from './leaves_Attendance/leaves_Attendance-data.js'
import holdsalary from './holdreleasesalary/holdsalary.js'
import releasesalary from './holdreleasesalary/releasesalary.js'
import form16 from './form16/form16.js'
import settlefbpclaimsemployeepage from './fbpClaims/settlefbpclaimsemployeepage.js'
import statutorybonus from './statutorybonus/statutorybonus.js'
import assignFixedNonCTCcomponents from './assignFixedNonCTCcomponents/assignFixedNonCTCcomponents.js'
import manageRoles from './manageRoles/manageRoles.js'
import addnewclaim from './addNewClaim/addnewclaim.js'
import approveFbpClaims from './approveFbpClaims/approveFbpClaims.js'
import fbpProcessMonth from './fbpProcessMonth/fbpProcessMonth.js'
import pushFbpConfiguration from './pushFbpConfiguration/pushFbpConfiguration.js'

export default {
    namespaced: true,
    modules: {
        settlefbpclaims: settlefbpclaims,
        uploadloprlop: uploadloprlop,
        viewloprlop: viewloprlop,
        addexitemployees: addexitemployees,
        uploadFbpClaim: uploadFbpClaim,
        revisesalary: revisesalary,
        leaves_attendance: leaves_attendance,
        assignfbpcomponents: assign_fbp_components,
        get_fbp: get_fbp,
        holdsalary: holdsalary,
        releasesalary: releasesalary,
        settlefbpclaimsemployeepage: settlefbpclaimsemployeepage,
        statutory_bonus: statutoryBonus,
        statutorybonus: statutorybonus,
        form16: form16,
        assignFixedNonCTCcomponents: assignFixedNonCTCcomponents,
        manageRoles: manageRoles,
        addnewclaim: addnewclaim,
        approveFbpClaims:approveFbpClaims,
        fbpProcessMonth: fbpProcessMonth,
        pushFbpConfiguration: pushFbpConfiguration
    }
};
